export interface SizeTypeConfig {
    label: string;
    value: string;
    image: string;
    imageFileName: string; // 언어별 이미지를 위한 파일명
    fields: string[];
    isPublic: boolean;
}

// 언어 코드 매핑 함수
export const getLanguageCode = (lang: string): string => {
    const langMap: Record<string, string> = {
        ko: 'ko',
        en: 'en',
        ja: 'ja',
        'zh-CN': 'cn',
        'zh-TW': 'tw',
        vi: 'vi',
    };
    return langMap[lang] || 'ko';
};

// 언어별 이미지 URL 생성 함수
export const getSizeGuideImageUrl = (fileName: string, language: string): string => {
    const langCode = getLanguageCode(language);
    return `https://d1vb419ubgm46b.cloudfront.net/size-guide/${langCode}/${fileName}`;
};

export const SIZE_TYPE_CONFIG: SizeTypeConfig[] = [
    {
        label: '반소매티셔츠',
        value: '반소매티셔츠',
        image: 'https://d1vb419ubgm46b.cloudfront.net/size-guide/ko/tshirt.jpg',
        imageFileName: 'tshirt.jpg',
        fields: ['어깨너비', '가슴단면', '밑단단면', '암홀단면', '소매길이', '소매단면', '총장'],
        isPublic: true,
    },
    {
        label: '반소매_래글런',
        value: '반소매_래글런',
        image: 'https://d1vb419ubgm46b.cloudfront.net/size-guide/ko/short_sleeve_raglan.jpg',
        imageFileName: 'short_sleeve_raglan.jpg',
        fields: ['가슴단면', '밑단단면', '소매길이', '소매단면', '총장'],
        isPublic: true,
    },
    {
        label: '민소매',
        value: '민소매',
        image: 'https://d1vb419ubgm46b.cloudfront.net/size-guide/ko/sleeveless.jpg',
        imageFileName: 'sleeveless.jpg',
        fields: ['어깨너비', '가슴단면', '밑단단면', '암홀단면', '소매단면', '총장'],
        isPublic: true,
    },
    {
        label: '긴소매티셔츠',
        value: '긴소매티셔츠',
        image: 'https://d1vb419ubgm46b.cloudfront.net/size-guide/ko/long_sleeve_tshirt.jpg',
        imageFileName: 'long_sleeve_tshirt.jpg',
        fields: ['어깨너비', '가슴단면', '밑단단면', '암홀단면', '소매길이', '소매단면', '총장'],
        isPublic: true,
    },
    {
        label: '긴소매_래글런',
        value: '긴소매_래글런',
        image: 'https://d1vb419ubgm46b.cloudfront.net/size-guide/ko/long_sleeve_raglan.jpg',
        imageFileName: 'long_sleeve_raglan.jpg',
        fields: ['가슴단면', '밑단단면', '소매길이', '소매단면', '총장'],
        isPublic: true,
    },
    {
        label: '셔츠',
        value: '셔츠',
        image: 'https://d1vb419ubgm46b.cloudfront.net/size-guide/ko/shirt.jpg',
        imageFileName: 'shirt.jpg',
        fields: ['어깨너비', '가슴단면', '밑단단면', '암홀단면', '소매길이', '소매단면', '총장'],
        isPublic: true,
    },
    {
        label: '베스트',
        value: '베스트',
        image: 'https://d1vb419ubgm46b.cloudfront.net/size-guide/ko/vest.jpg',
        imageFileName: 'vest.jpg',
        fields: ['어깨너비', '가슴단면', '밑단단면', '암홀단면', '총장'],
        isPublic: true,
    },
    {
        label: '점퍼',
        value: '점퍼',
        image: 'https://d1vb419ubgm46b.cloudfront.net/size-guide/ko/jumper.jpg',
        imageFileName: 'jumper.jpg',
        fields: ['어깨너비', '가슴단면', '밑단단면', '암홀단면', '소매길이', '소매단면', '총장'],
        isPublic: true,
    },
    {
        label: '점퍼_래글런',
        value: '점퍼_래글런',
        image: 'https://d1vb419ubgm46b.cloudfront.net/size-guide/ko/jumper_raglan.jpg',
        imageFileName: 'jumper_raglan.jpg',
        fields: ['가슴단면', '밑단단면', '소매길이', '소매단면', '총장'],
        isPublic: true,
    },
    {
        label: '코트',
        value: '코트',
        image: 'https://d1vb419ubgm46b.cloudfront.net/size-guide/ko/coat.jpg',
        imageFileName: 'coat.jpg',
        fields: ['어깨너비', '가슴단면', '밑단단면', '암홀단면', '소매길이', '소매단면', '총장'],
        isPublic: true,
    },
    {
        label: '자켓',
        value: '자켓',
        image: 'https://d1vb419ubgm46b.cloudfront.net/size-guide/ko/jacket.jpg',
        imageFileName: 'jacket.jpg',
        fields: ['어깨너비', '가슴단면', '밑단단면', '암홀단면', '소매길이', '소매단면', '총장'],
        isPublic: true,
    },
    {
        label: '원피스',
        value: '원피스',
        image: 'https://d1vb419ubgm46b.cloudfront.net/size-guide/ko/dress.jpg',
        imageFileName: 'dress.jpg',
        fields: [
            '어깨너비',
            '가슴단면',
            '허리단면',
            '엉덩이단면',
            '밑단단면',
            '암홀단면',
            '소매길이',
            '소매단면',
            '총장',
        ],
        isPublic: true,
    },
    {
        label: '바지',
        value: '바지',
        image: 'https://d1vb419ubgm46b.cloudfront.net/size-guide/ko/pants.jpg',
        imageFileName: 'pants.jpg',
        fields: ['허리단면', '엉덩이단면', '밑단단면', '밑위', '허벅지단면', '총장'],
        isPublic: true,
    },
    {
        label: '반바지',
        value: '반바지',
        image: 'https://d1vb419ubgm46b.cloudfront.net/size-guide/ko/shorts.jpg',
        imageFileName: 'shorts.jpg',
        fields: ['허리단면', '엉덩이단면', '밑단단면', '밑위', '허벅지단면', '총장'],
        isPublic: true,
    },
    {
        label: '레깅스',
        value: '레깅스',
        image: 'https://d1vb419ubgm46b.cloudfront.net/size-guide/ko/leggings.jpg',
        imageFileName: 'leggings.jpg',
        fields: ['허리단면', '엉덩이단면', '밑단단면', '밑위', '허벅지단면', '총장'],
        isPublic: true,
    },
    {
        label: '스커트',
        value: '스커트',
        image: 'https://d1vb419ubgm46b.cloudfront.net/size-guide/ko/skirt.jpg',
        imageFileName: 'skirt.jpg',
        fields: ['허리단면', '엉덩이단면', '밑단단면', '총장'],
        isPublic: true,
    },
    {
        label: '브라',
        value: '브라',
        image: 'https://d1vb419ubgm46b.cloudfront.net/size-guide/ko/bra.jpg',
        imageFileName: 'bra.jpg',
        fields: ['윗가슴둘레', '밑가슴둘레', '날개폭'],
        isPublic: true,
    },
    {
        label: '팬티',
        value: '팬티',
        image: 'https://d1vb419ubgm46b.cloudfront.net/size-guide/ko/underwear.jpg',
        imageFileName: 'underwear.jpg',
        fields: ['허리단면', '엉덩이둘레', '밑위', '사이드폭'],
        isPublic: true,
    },
    {
        label: '모자',
        value: '모자',
        image: 'https://d1vb419ubgm46b.cloudfront.net/size-guide/ko/hat.jpg',
        imageFileName: 'hat.jpg',
        fields: ['머리둘레', '챙길이', '깊이'],
        isPublic: true,
    },
    {
        label: '안경',
        value: '안경',
        image: 'https://d1vb419ubgm46b.cloudfront.net/size-guide/ko/glasses.jpg',
        imageFileName: 'glasses.jpg',
        fields: ['전체너비', '렌즈너비', '렌즈높이', '브릿지길이', '다리길이'],
        isPublic: true,
    },
    {
        label: '스니커즈',
        value: '스니커즈',
        image: 'https://d1vb419ubgm46b.cloudfront.net/size-guide/ko/sneakers.jpg',
        imageFileName: 'sneakers.jpg',
        fields: ['발목높이', '굽높이', '발길이', '발볼'],
        isPublic: true,
    },
    {
        label: '백팩',
        value: '백팩',
        image: 'https://d1vb419ubgm46b.cloudfront.net/size-guide/ko/backpack.jpg',
        imageFileName: 'backpack.jpg',
        fields: ['너비', '높이', '폭'],
        isPublic: true,
    },
    {
        label: '크로스백',
        value: '크로스백',
        image: 'https://d1vb419ubgm46b.cloudfront.net/size-guide/ko/crossbag.jpg',
        imageFileName: 'crossbag.jpg',
        fields: ['너비', '높이', '폭', '끈길이'],
        isPublic: true,
    },
];

export const TOP_SIZE_LIST = [
    'Free',
    'XXXS',
    'XXS',
    'XS',
    'S',
    'M',
    'L',
    'XL',
    '2XL',
    '3XL',
    '4XL',
    '5XL',
    '44',
    '44반',
    '55',
    '55반',
    '66',
    '66반',
    '77',
    '77반',
    '88',
    '99',
    '75',
    '80',
    '85',
    '90',
    '95',
    '100',
    '103',
    '105',
    '110',
    '115',
    '120',
    '125',
    '130',
];
export const BOTTOM_SIZE_LIST = [
    'Free',
    '23',
    '24',
    '25',
    '26',
    '27',
    '28',
    '29',
    '30',
    '31',
    '32',
    '33',
    '34',
    '35',
    '36',
    '37',
    '38',
    '39',
    '40',
    '42',
    '44',
];
